import { Toast } from "primereact/toast";

class ToastService {
    private toast: Toast | null = null;

    setRef(ref: Toast | null) {
        this.toast = ref;
    }

    success(detail: string, summary = "Success") {
        this.toast?.show({ severity: "success", summary, detail, life: 3000 });
    }

    // sticky keeps the toast until the user closes it; life (ms) lets a longer message stay up longer.
    // Every existing caller keeps the 3-second default.
    error(detail: string, summary = "Error", sticky = false, life = 3000) {
        this.toast?.show({ severity: "error", summary, detail, life, sticky });
    }

    warn(detail: string, summary = "Warning") {
        this.toast?.show({ severity: "warn", summary, detail, life: 3000 });
    }

    info(detail: string, summary = "Info", life = 3000) {
        this.toast?.show({ severity: "info", summary, detail, life });
    }
}

export const toastService = new ToastService();
